import RespondentsStats from './components/RespondentsStats';
export default RespondentsStats;
